import React, { useState } from "react";
import GMap from "../gComponents/gMaps";
import { ApiService } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GGeoTagsInput from "../gComponents/gGeofencesInput";
import { useLocation } from "react-router-dom";
import GButton from "../gComponents/gButton";
import useDataFctory from "../useDataFactory";
import useSettings from "../useSettings";

export default function CreateStore(props) {
  const settings = useSettings(true);
  const [openSnackbar] = useSnackbar();
  const location = useLocation();
  const { data: branchesData } = useDataFctory("branches", false);
  const { data: brandsData } = useDataFctory("brands", false);
  const [geofencesList, setGeofencesList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const initialValues = {
    title: props.data ? props.data.title : "",
    phone: props.data ? props.data.phone : "",
    address: props.data ? props.data.address : "",
    photo: "",
    latitude: "",
    longitude: "",
    commission: "",
    pack_time: "",
    order_type: "",
    delivery_type: "",
    geofences: [],
    branch_id: "",
    aerial_distance: "",
    brand_id: "",
    aerialDistance: 0,
  };

  

  const onSubmit = (values) => {
    setIsDisabled(true);
    let sendData = { ...values };
    sendData.aerial_distance = sendData.aerial_distance || 0;
    console.log(sendData);
    //return;
    ApiService({ method: "POST", route: "stores", body: sendData }).then(
      (response) => {
        console.log("r" + response.data.status_code);
        openSnackbar(response.data.message);
        if (response.data.status_code === 1) {
          if (location.pathname === "/stores") {
            window.location.reload(false);
          } else {
            window.location = "/stores";
          }
          props.setCsvisible(false);
        }
        setIsDisabled(false);
        return;
      }
    );
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
    phone: Yup.string().required("Required"),
    address: Yup.string().required("Required"),
    commission: Yup.string().required("Required"),
  });

  if (props.csvisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header"> Create Store </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div style={{ display: "inline-flex" }}>
                <FormikControl
                  control="input"
                  type="text"
                  label="Title"
                  name="title"
                />
                <FormikControl
                  control="input"
                  type="text"
                  label="Phone"
                  name="phone"
                  onChange={(event) => {
                    const re = /^[0-9-+\b]+$/;
                    if (event.target.value && !re.test(event.target.value)) {
                      return;
                    } else {
                      setFieldValue("phone", event.target.value);
                    }
                  }}
                />
              </div>

              <GMap
                centerLocation={{
                  lat: process.env.REACT_APP_DEFAULT_LATITUDE || 30.7046,
                  lng: process.env.REACT_APP_DEFAULT_LONGITUDE || 76.7179,
                }}
                search={true}
                height="30vh"
                type="createStore"
                onChange={(address, loc) => {
                  values.latitude = loc.lat();
                  values.longitude = loc.lng();
                  setFieldValue("address", address.address);
                }}
                label="Location"
                padding={true}
              />

              <FormikControl
                control="input"
                type="text"
                label="Address"
                name="address"
              />

              <h4 style={{ margin: "15px 15px 10px" }}>
                Additional Information
              </h4>
              <FormikControl
                control="input"
                type="text"
                label="Commission (in %)"
                name="commission"
                divstyle={{
                  display: "inline-block",
                  width: "50%",
                  boxSizing: "border-box",
                  verticalAlign: "top",
                }}
              />

              {branchesData && (
                <FormikControl
                  control="select"
                  as="select"
                  label="Branches"
                  name="branch_id"
                  options={branchesData}
                  key_title="title"
                  key_value="id"
                  divstyle={{
                    display: "inline-block",
                    width: "50%",
                    boxSizing: "border-box",
                    verticalAlign: "top",
                  }}
                />
              )}

              {brandsData &&
                brandsData.length >= 0 &&
                settings?.brands_available == 1 && (
                  <FormikControl
                    control="select"
                    as="select"
                    label="Brand"
                    name="brand_id"
                    options={brandsData}
                    key_title="title"
                    key_value="id"
                    divstyle={{
                      display: "inline-block",
                      width: "50%",
                      boxSizing: "border-box",
                      verticalAlign: "top",
                    }}
                  />
                )}

              <div
                style={{
                  display: "flex",
                  margin: "0 15px",
                  minHeight: "55px",
                  alignItems: "center",
                }}
              >
                <label style={{ width: "140px" }}>Max Listing Distance</label>
                <FormikControl
                  control="toggle"
                  label=""
                  isToggled={values.aerialDistance}
                  name="serial_distance"
                  iconType="google"
                  onToggle={() => {
                    let unlimitedVal =
                      values.aerialDistance == 1 ? true : false;
                    unlimitedVal = !unlimitedVal;
                    unlimitedVal = unlimitedVal === true ? 1 : 0;
                    setFieldValue("aerialDistance", unlimitedVal);
                  }}
                />
                {values.aerialDistance === "1" ||
                values.aerialDistance === 1 ? (
                  <FormikControl
                    control="input"
                    type="text"
                    name="aerial_distance"
                    className="noBorder noMargin"
                    style={{ width: "150px" }}
                    onChange={(event) => {
                      const re = /^[0-9\b]+$/;
                      if (event.target.value && !re.test(event.target.value)) {
                        return;
                      } else {
                        setFieldValue("aerial_distance", event.target.value);
                      }
                    }}
                  />
                ) : (
                  ""
                )}
              </div>

              <div style={{ margin: "15px" }}>
                <label>Geofences</label>
                <GGeoTagsInput
                  data={geofencesList}
                  onSubmit={(tags) => {
                    console.log(tags);
                    values.geofences = tags.map((d) => d.id);
                  }}
                  showButton={false}
                />
              </div>

              <br />

              <GButton
                type="submit"
                disabled={isDisabled}
                variant="condensed"
                children={"Create"}
                style={{ margin: "0 15px", width: "calc(100% - 30px)" }}
              />
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}
